"use client"
import StoryText from "@/app/(site)/_components/Atoms/Storytext"
import { usePathname, useSearchParams } from "next/navigation"
import { useEffect } from "react"

export interface KlaviyoSectionType {
    klaviyoId: string
    title: string
}

interface KlaviyoSectionProps {
    data: KlaviyoSectionType
}
export default function KlaviyoSection({ data }: KlaviyoSectionProps) {
    const pathname = usePathname()
    const searchParams = useSearchParams()
    const selector = `.klaviyo-form-${data.klaviyoId}`

    useEffect(() => {
        reinitEmbed()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname, searchParams])

    // back/forward + bfCache
    useEffect(() => {
        const onPop = () => reinitEmbed()
        const onPageShow = (e: PageTransitionEvent) => {
            if ((e as any).persisted) reinitEmbed()
        }
        window.addEventListener("popstate", onPop)
        window.addEventListener("pageshow", onPageShow)
        reinitEmbed()
        return () => {
            window.removeEventListener("popstate", onPop)
            window.removeEventListener("pageshow", onPageShow)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function reinitEmbed() {
        const root = document.querySelector(selector)
        if (!root) return

        const already = root.querySelector(
            "form, iframe, .klaviyo-form, [data-klaviyo-form-id]"
        )
        if (already) return

        // Force “remount”
        requestAnimationFrame(() => {
            const parent = root.parentElement
            if (!parent) return
            const clone = root.cloneNode(false)
            parent.replaceChild(clone, root)
        })
    }

    return (
        <div className="border-t border-black pt-12 md:pt-8">
            {data?.title && (
                <StoryText size="size3" className="mb-24 uppercase">
                    {data?.title}
                </StoryText>
            )}
            <div className={`klaviyo-form-${data?.klaviyoId}`}></div>
        </div>
    )
}
